import React from 'react';
import _t from 'counterpart';
import { CBadge } from '@coreui/react';

const BooleanBadge = ({ value }: { value: boolean }) => {
  return <CBadge color={value ? 'success' : 'danger'}>{value ? _t('global.yes') : _t('global.no')}</CBadge>;
};

export default BooleanBadge;
